import { BOOLEAN, NUMBER, NUMBER_CSV, STRING, STRING_CSV } from './utils';
import type { FrontendEnvironmentConfig } from './frontend-environment-config';
import {
  getBooleanOverride,
  getNumberListOverride,
  getNumberOverride,
  getStringListOverride,
  getStringOverride,
} from './frontend-config-overrides';
import { maybe } from 'true-myth';

export const getNumberConfigWithEnv = (name: string, config: FrontendEnvironmentConfig<number>) =>
  getNumberOverride(name) ??
  NUMBER()
    .andThen((number) => maybe.of(number[name]))
    .unwrapOrElse(() => config.getValue());

export const getStringConfigWithEnv = (name: string, config: FrontendEnvironmentConfig<string>) =>
  getStringOverride(name) ??
  STRING()
    .andThen((string) => maybe.of(string[name]))
    .unwrapOrElse(() => config.getValue());

export const getBooleanConfigWithEnv = (name: string, config: FrontendEnvironmentConfig<boolean>) =>
  getBooleanOverride(name) ??
  BOOLEAN()
    .andThen((boolean) => maybe.of(boolean[name]))
    .unwrapOrElse(() => config.getValue());

export const getStringListConfigWithEnv = (name: string, config: FrontendEnvironmentConfig<Array<string>>) =>
  getStringListOverride(name) ??
  STRING_CSV()
    .andThen((stringCsv) => maybe.of(stringCsv[name]))
    .map((csv) => csv.split(','))
    .unwrapOrElse(() => config.getValue());

export const getNumberListConfigWithEnv = (name: string, config: FrontendEnvironmentConfig<Array<number>>) =>
  getNumberListOverride(name) ??
  NUMBER_CSV()
    .andThen((numberCsv) => maybe.of(numberCsv[name]))
    .map((csv) => csv.split(',').map(Number))
    .unwrapOrElse(() => config.getValue());
